import React, { useState } from "react";
import TrainingPeriod from "../../types/TrainingPeriod";

interface TrainingPeriodFormProps {
  trainingPeriod: TrainingPeriod;
  onSave: (trainingPeriod: TrainingPeriod) => void;
  onCancel: () => void;
}

const TrainingPeriodForm: React.FC<TrainingPeriodFormProps> = ({ trainingPeriod, onSave, onCancel }) => {
  const [formData, setFormData] = useState<TrainingPeriod>(trainingPeriod);
  const [errorMessage, setErrorMessage] = useState<string | null>(null); // For validation messages

  // Handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "date" ? new Date(value) : value, // Parse date inputs
    }));
  };

  // Validate before saving
  const validateForm = (): boolean => {
    if (formData.endDate < formData.startDate) {
      setErrorMessage("Data zakończenia nie może być wcześniejsza niż data rozpoczęcia.");
      return false;
    }
    setErrorMessage(null);
    return true;
  };

  // Handle form submission
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    const updatedFormData: TrainingPeriod = {
      ...formData,
      startDate: new Date(formData.startDate),
      endDate: new Date(formData.endDate),
    };

    onSave(updatedFormData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="name">Nazwa</label>
        <input
          type="text"
          id="name"
          name="name"
          className="form-control"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="type">Typ</label>
        <select
          id="type"
          name="type"
          className="form-control"
          value={formData.type}
          onChange={handleInputChange}
        >
          <option value="CAMP">Obóz</option>
          <option value="COMPETITION">Zawody</option>
          <option value="OTHER">Inne</option>
        </select>
      </div>
      <div className="form-group row">
        <div className="col-md-6">
          <label htmlFor="startDate">Data rozpoczęcia</label>
          <input
            type="date"
            id="startDate"
            name="startDate"
            className="form-control"
            value={formData.startDate.toISOString().split("T")[0]} // Convert Date to YYYY-MM-DD format
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="endDate">Data zakończenia</label>
          <input
            type="date"
            id="endDate"
            name="endDate"
            className="form-control"
            value={formData.endDate.toISOString().split("T")[0]} // Convert Date to YYYY-MM-DD format
            onChange={handleInputChange}
            required
          />
        </div>
      </div>
      {/* Display error messages */}
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="form-group d-flex justify-content-between">
        <button type="submit" className="btn btn-primary">
          Zapisz
        </button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Anuluj
        </button>
      </div>
    </form>
  );
};

export default TrainingPeriodForm;
